// ========================================
// BOTÃO FLUTUANTE DE COMPRA - MOBILE V3
// Versão com CSS forçado e debug visual
// ========================================

(function() {
  'use strict';
  
  const DEBUG = true;
  
  function log(...args) {
    if (DEBUG) console.log('[FloatingButton]', ...args);
  }
  
  const CONFIG = {
    mobileBreakpoint: 768,
    offsetTrigger: 50,
    // Se não conseguirmos localizar o botão original, mostramos após um pequeno scroll
    fallbackScrollYToShow: 120,
  };
  
  log('Script iniciado');
  
  function waitForDOM(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }
  
  function addStyles() {
    const styleId = 'floating-buy-styles';
    if (document.getElementById(styleId)) {
      log('Estilos já existem');
      return;
    }
    
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #floating-buy-bar {
        position: fixed !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        background: #ffffff !important;
        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15) !important;
        z-index: 999999 !important;
        transform: translateY(110%) !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease, visibility 0s linear 0.2s !important;
        display: block !important;
        border-top: 1px solid #e5e5e5 !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      #floating-buy-bar.visible {
        transform: translateY(0) !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease !important;
      }
      
      #floating-buy-bar * {
        box-sizing: border-box !important;
      }
      
      .floating-buy-content {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding: 12px 16px !important;
        gap: 12px !important;
        max-width: 100% !important;
        margin: 0 !important;
      }
      
      .floating-product-info {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        flex: 1 !important;
        min-width: 0 !important;
      }
      
      .floating-product-image {
        width: 50px !important;
        height: 50px !important;
        border-radius: 6px !important;
        background-size: cover !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
        flex-shrink: 0 !important;
        border: 1px solid #e5e5e5 !important;
      }
      /* Removemos detalhes (título/preço) a pedido: somente foto + botão */
      
      .floating-buy-button {
        background: #0c3a39 !important;
        color: #fff !important;
        border: none !important;
        padding: 14px 28px !important;
        border-radius: 4px !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        cursor: pointer !important;
        white-space: nowrap !important;
        flex-shrink: 0 !important;
        transition: all 0.2s ease !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
        margin: 0 !important;
        outline: none !important;
        -webkit-appearance: none !important;
        appearance: none !important;
      }
      
      .floating-buy-button:hover {
        background: #333 !important;
      }
      
      .floating-buy-button:active {
        transform: scale(0.96) !important;
      }
      
      /* Mostra apenas em mobile */
      @media (min-width: ${CONFIG.mobileBreakpoint}px) {
        #floating-buy-bar {
          display: none !important;
        }
      }
      
      @media (max-width: 360px) {
        .floating-buy-button {
          padding: 12px 20px !important;
          font-size: 14px !important;
        }
      }
      
      /* Garante que nada bloqueie o botão */
      body.has-floating-button {
        padding-bottom: 0 !important;
      }
    `;
    document.head.appendChild(style);
    log('✅ Estilos adicionados com !important');
  }
  
  function createFloatingBar() {
    const existingBar = document.getElementById('floating-buy-bar');
    if (existingBar) {
      log('Barra flutuante já existe, removendo antiga');
      existingBar.remove();
    }
    
    const floatingBar = document.createElement('div');
    floatingBar.id = 'floating-buy-bar';
    floatingBar.innerHTML = `
      <div class="floating-buy-content">
        <div class="floating-product-info">
          <div class="floating-product-image"></div>
        </div>
        <button class="floating-buy-button" type="button">
          Adicionar ao carrinho
        </button>
      </div>
    `;
    
    document.body.appendChild(floatingBar);
    document.body.classList.add('has-floating-button');
    
    log('✅ Barra flutuante criada e adicionada ao body');
    log('Elemento criado:', floatingBar);
    
    return floatingBar;
  }

  function isMobileViewport() {
    // matchMedia tende a ser mais confiável que innerWidth em alguns cenários de viewport/zoom
    if (typeof window.matchMedia === 'function') {
      return window.matchMedia(`(max-width: ${CONFIG.mobileBreakpoint - 1}px)`).matches;
    }
    return window.innerWidth < CONFIG.mobileBreakpoint;
  }

  function isElementInViewport(el, margin = 0) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    const r = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    return (
      r.bottom > margin &&
      r.right > margin &&
      r.top < (vh - margin) &&
      r.left < (vw - margin)
    );
  }

  function getEffectivePosition(el) {
    try {
      return window.getComputedStyle(el).position;
    } catch (e) {
      return '';
    }
  }
  
  function findOriginalButton() {
    const selectors = [
      'button[name="add"]',
      'button[type="submit"][name="add"]',
      '.product-form__submit',
      'button.product-form__submit',
      'form[action*="/cart/add"] button[type="submit"]',
      '[data-add-to-cart]',
      'button.btn--add-to-cart',
      '.product-form button[type="submit"]',
    ];
    
    for (const selector of selectors) {
      try {
        const btn = document.querySelector(selector);
        if (btn && btn.offsetParent !== null) {
          log('✅ Botão original encontrado:', selector);
          log('Elemento:', btn);
          return btn;
        }
      } catch(e) {
        // Ignora
      }
    }
    
    const buttons = document.querySelectorAll('button, input[type="submit"]');
    for (const btn of buttons) {
      const text = btn.textContent.toLowerCase();
      if (text.includes('adicionar') || text.includes('comprar') || text.includes('add')) {
        log('✅ Botão encontrado por texto:', btn.textContent.trim());
        return btn;
      }
    }
    
    log('❌ Botão original NÃO encontrado');
    return null;
  }

  function findProductForm(originalButton) {
    // Prioridade: o form mais próximo do botão encontrado
    const fromButton = originalButton && (originalButton.closest && originalButton.closest('form[action*="/cart/add"], form[action*="cart/add"]'));
    if (fromButton) return fromButton;

    // Fallbacks comuns em temas Shopify
    const selectors = [
      'form[action*="/cart/add"]',
      'form[action*="cart/add"]',
      'form[data-type="add-to-cart-form"]',
      'product-form form',
      '[data-product-form] form',
    ];

    for (const s of selectors) {
      const el = document.querySelector(s);
      if (el) return el;
    }
    return null;
  }

  function getSelectedVariantId(productForm) {
    // Dawn e a maioria dos temas sempre mantém um input name="id" com o variant selecionado
    const candidates = productForm
      ? productForm.querySelectorAll('[name="id"]')
      : document.querySelectorAll('form[action*="/cart/add"] [name="id"], [name="id"]');

    for (const el of candidates) {
      const v = (el.value || '').toString().trim();
      if (/^\d+$/.test(v)) return v;
    }

    // fallback: ?variant=123 na URL
    try {
      const u = new URL(window.location.href);
      const v = u.searchParams.get('variant');
      if (v && /^\d+$/.test(v)) return v;
    } catch (e) {}

    return null;
  }

  function getQuantity(productForm) {
    if (!productForm) return 1;
    const qty = productForm.querySelector('[name="quantity"]');
    const raw = qty ? parseInt(qty.value, 10) : 1;
    return Number.isFinite(raw) && raw > 0 ? raw : 1;
  }

  async function addToCartAjax(variantId, quantity) {
    const body = new URLSearchParams();
    body.set('id', String(variantId));
    body.set('quantity', String(quantity || 1));

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: body.toString(),
      credentials: 'same-origin',
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(`Falha ao adicionar ao carrinho (${res.status}). ${txt}`);
    }

    return await res.json().catch(() => ({}));
  }

  function openCartUI() {
    // tenta abrir drawer do tema, senão vai pro /cart
    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="cart"][id*="drawer"]') ||
      document.querySelector('[class*="cart"][class*="drawer"]');

    if (drawer) {
      try {
        if (typeof drawer.open === 'function') return drawer.open();
        if (typeof drawer.show === 'function') return drawer.show();
        drawer.setAttribute('open', '');
        return;
      } catch (e) {}
    }

    window.location.href = '/cart';
  }

  function syncFloatingButtonState(floatingBar, originalButton, productForm) {
    const floatingButton = floatingBar.querySelector('.floating-buy-button');
    if (!floatingButton) return;

    // tenta espelhar o estado do botão original
    const isDisabled =
      (originalButton && (originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true')) ||
      false;

    const variantId = getSelectedVariantId(productForm);

    // se não há variant (produto variável sem seleção), considera indisponível pro clique
    const shouldDisable = isDisabled || !variantId;
    floatingButton.disabled = shouldDisable;
    floatingButton.style.opacity = shouldDisable ? '0.7' : '1';

    if (shouldDisable && !variantId) {
      floatingButton.textContent = 'Selecione uma opção';
    } else {
      floatingButton.textContent = 'Adicionar ao carrinho';
    }
  }
  
  function populateProductInfo(floatingBar) {
    log('Populando informações do produto...');
    
    // Imagem
    const imageSelectors = [
      '.product__media img',
      '.product-gallery img',
      '.product-single__photo img',
      '[data-product-single-media-wrapper] img',
      '.product__image img',
      'meta[property="og:image"]'
    ];
    
    let imageUrl = null;
    for (const selector of imageSelectors) {
      const el = document.querySelector(selector);
      if (el) {
        imageUrl = el.tagName === 'META' ? el.content : el.src;
        if (imageUrl) {
          log('✅ Imagem encontrada:', imageUrl);
          break;
        }
      }
    }
    
    if (imageUrl) {
      floatingBar.querySelector('.floating-product-image').style.backgroundImage = `url(${imageUrl})`;
    }
  }
  
  function updatePrice(floatingBar) {
    // Se não exibimos preço, não há o que atualizar
    const priceEl = floatingBar && floatingBar.querySelector
      ? floatingBar.querySelector('.floating-product-price')
      : null;
    if (!priceEl) return;

    const priceSelectors = [
      '.price__current .price-item--regular',
      '.product__price .price-item',
      '.product-single__price',
      '.product__price',
      '[data-product-price]',
      '.price',
      'span[itemprop="price"]',
      'meta[property="product:price:amount"]'
    ];
    
    for (const selector of priceSelectors) {
      const el = document.querySelector(selector);
      if (el) {
        const price = el.tagName === 'META' ? `R$ ${el.content}` : el.textContent.trim();
        if (price && price.includes('R$')) {
          priceEl.textContent = price;
          log('✅ Preço atualizado:', price);
          return;
        }
      }
    }
  }
  
  function setupScrollBehavior(floatingBar, originalButton) {
    log('Configurando scroll...');
    
    let ticking = false;
    let isVisible = false;
    const originalPosition = originalButton ? getEffectivePosition(originalButton) : '';
    
    function checkScroll() {
      const isMobile = isMobileViewport();
      
      log('Check scroll - isMobile:', isMobile, 'width:', window.innerWidth);
      
      if (!isMobile) {
        floatingBar.classList.remove('visible');
        isVisible = false;
        log('Ocultando - não é mobile');
        return;
      }

      if (!originalButton) {
        // Fallback: se não achamos o botão original, mostramos após um pequeno scroll
        const shouldShowFallback = (window.scrollY || window.pageYOffset || 0) >= CONFIG.fallbackScrollYToShow;
        if (shouldShowFallback && !isVisible) {
          floatingBar.classList.add('visible');
          isVisible = true;
          log('🎯 Botão flutuante VISÍVEL (modo fallback)');
          log('Classes do elemento:', floatingBar.className);
          log('Computed style display:', window.getComputedStyle(floatingBar).display);
          log('Computed style transform:', window.getComputedStyle(floatingBar).transform);
        } else if (!shouldShowFallback && isVisible) {
          floatingBar.classList.remove('visible');
          isVisible = false;
          log('⬇️ Botão flutuante OCULTO (fallback, topo da página)');
        }
        return;
      }
      
      // Regra mais confiável: mostra quando o botão original NÃO estiver no viewport.
      // Isso evita casos em que a posição do botão varia/é renderizada em etapas.
      // Se o botão original for position:fixed/sticky (sempre visível), mantemos o flutuante oculto.
      const inViewport = isElementInViewport(originalButton, 0);
      const isFixedOrSticky = originalPosition === 'fixed' || originalPosition === 'sticky';
      const shouldShow = !inViewport && !isFixedOrSticky;
      
      log('Botão original - inViewport:', inViewport, 'position:', originalPosition, 'shouldShow:', shouldShow);
      
      if (shouldShow && !isVisible) {
        floatingBar.classList.add('visible');
        isVisible = true;
        log('🎯 Botão flutuante VISÍVEL');
        log('Classes:', floatingBar.className);
      } else if (!shouldShow && isVisible) {
        floatingBar.classList.remove('visible');
        isVisible = false;
        log('⬇️ Botão flutuante OCULTO');
      }
      
      ticking = false;
    }
    
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(checkScroll);
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    
    // Força verificação inicial após pequeno delay
    setTimeout(() => {
      log('⏰ Verificação inicial do scroll');
      checkScroll();
    }, 500);
    
    // Verificação adicional após 1 segundo
    setTimeout(() => {
      log('⏰ Verificação adicional após 1s');
      checkScroll();
    }, 1000);
  }
  
  function setupButtonAction(floatingBar, originalButton, productForm) {
    const floatingButton = floatingBar.querySelector('.floating-buy-button');
    
    floatingButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      log('🖱️ Botão flutuante clicado');
      
      const form = productForm || findProductForm(originalButton);
      const variantId = getSelectedVariantId(form);
      const quantity = getQuantity(form);

      if (!variantId) {
        log('❌ Variant ID não encontrado (provavelmente produto variável sem seleção)');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        alert('Selecione uma opção do produto (variante) para adicionar ao carrinho.');
        return;
      }
      
      // 1) Caminho ideal: usar requestSubmit para acionar o JS do tema (drawer/AJAX/validações)
      if (form) {
        try {
          log('✅ Enviando form do produto via requestSubmit');
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(originalButton || undefined);
            return;
          }
        } catch (err) {
          log('⚠️ requestSubmit falhou, tentando fallback', err);
        }
      }

      // 2) Fallback: POST direto no endpoint Ajax da Shopify
      (async () => {
        try {
          log('🛒 Fallback Ajax /cart/add.js', { variantId, quantity });
          await addToCartAjax(variantId, quantity);
          openCartUI();
        } catch (err) {
          log('❌ Falha ao adicionar via Ajax', err);
          alert('Não foi possível adicionar ao carrinho. Tente novamente ou role até o formulário do produto.');
        }
      })();
    });
    
    log('✅ Ação do botão configurada');
  }

  function observeVariantChanges(floatingBar, originalButton, productForm) {
    // Eventos comuns em temas Shopify/Dawn
    document.addEventListener('variant:change', (e) => {
      log('🔁 variant:change detectado', e && e.detail ? e.detail : '');
      updatePrice(floatingBar);
      syncFloatingButtonState(floatingBar, originalButton, productForm);
    });

    // Mudanças diretas no input/select de variant id
    document.addEventListener('change', (e) => {
      const t = e && e.target;
      if (!t || !t.matches) return;
      if (t.matches('[name="id"], [name="quantity"]') || (productForm && productForm.contains(t))) {
        updatePrice(floatingBar);
        syncFloatingButtonState(floatingBar, originalButton, productForm);
      }
    });

    // Também observa mutações no input id, pois alguns temas atualizam via JS sem disparar change
    const idEl = productForm ? productForm.querySelector('[name="id"]') : null;
    if (idEl) {
      const obs = new MutationObserver(() => {
        updatePrice(floatingBar);
        syncFloatingButtonState(floatingBar, originalButton, productForm);
      });
      obs.observe(idEl, { attributes: true, attributeFilter: ['value'] });
    }
  }
  
  function observePriceChanges(floatingBar) {
    const priceContainer = document.querySelector('.product__price, .product-single__price, .price');
    if (!priceContainer) {
      log('⚠️ Container de preço não encontrado');
      return;
    }
    
    const observer = new MutationObserver(() => {
      log('💰 Preço alterado');
      updatePrice(floatingBar);
    });
    
    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
    
    log('✅ Observador de preço ativado');
  }
  
  function init() {
    log('🚀 Inicializando...');
    
    const isProductPage = document.body.classList.contains('template-product') ||
                          window.location.pathname.includes('/products/') ||
                          document.querySelector('[itemtype="http://schema.org/Product"], [itemtype="https://schema.org/Product"]') ||
                          document.querySelector('meta[property="og:type"][content*="product"]');
    
    if (!isProductPage) {
      log('❌ Não é página de produto');
      return;
    }
    
    log('✅ Página de produto detectada');
    
    addStyles();
    const floatingBar = createFloatingBar();
    const originalButton = findOriginalButton();
    const productForm = findProductForm(originalButton);
    
    populateProductInfo(floatingBar);
    setupScrollBehavior(floatingBar, originalButton);
    setupButtonAction(floatingBar, originalButton, productForm);
    observePriceChanges(floatingBar);
    observeVariantChanges(floatingBar, originalButton, productForm);
    syncFloatingButtonState(floatingBar, originalButton, productForm);
    
    log('✅ Inicialização completa!');
    log('📱 Para ver o botão: role a página no mobile ou force width < 768px');
    
    // Log adicional de debug
    setTimeout(() => {
      log('🔍 DEBUG - Estado do botão após 2s:');
      log('  Display:', window.getComputedStyle(floatingBar).display);
      log('  Transform:', window.getComputedStyle(floatingBar).transform);
      log('  Z-index:', window.getComputedStyle(floatingBar).zIndex);
      log('  Classes:', floatingBar.className);
      log('  Largura da janela:', window.innerWidth);
      log('  Variant selecionada:', getSelectedVariantId(productForm));
    }, 2000);
  }
  
  waitForDOM(init);
  
})();
